import React, { Component } from 'react';
import { FONT_GSS_FUTURA } from 'themes/default';
import withStyles from 'components/@layout/withStyles';
import withModal from '@lwtears/lwt-common-frontend/lib/Modal/withModal';
import withRouter from 'components/App/hooks/with-router';
import { compose } from 'redux';
import { AppStoreState, Frametype, LiteResource } from 'types';
import { connect } from 'react-redux';
import { selectResource } from 'state/modules/app';
import { getSwitchFrameType } from 'util/resources-util';
import ResourceModal from 'components/@common/Modals/ResourcePlayer';
import { createEvent } from 'api/telemetry';

import SupportDocumentTile from './SupportDocumentTile';
import { parseQueryParams } from 'util/query-params-util';

type Props = {
  classes: any;
  selectedResource: LiteResource;
  selectResource: (resource: LiteResource) => void;
  openDraggableModal: (prop: any) => void;
  frameType: Frametype;
  supportResources: any;
  router: any;
};

class SupportDocuments extends Component<Props, any> {
  constructor(props: Props) {
    super(props);
    this.state = { supportDocuments: [] };
  }

  createTelemetryEvent = (resource: LiteResource) =>
    createEvent('accessResource', {
      section: 'resources',
      resourceId: resource.id,
      resourceType: resource.type.type
    });
  handleSelectResource = async (resource: LiteResource) => {
    await this.props.selectResource(resource);
    this.openResourceModal(resource);
  };

  openResourceModal = (selectedResource): void => {
    this.props.openDraggableModal({
      titleText: selectedResource.title,
      body: (
        <ResourceModal
          selectedResource={selectedResource}
          frameType={this.props.frameType}
          handleClose={() => {}}
          eventLogger={() => this.createTelemetryEvent(selectedResource)}
        />
      ),
      options: { closeOnBackdropClick: true }
    });
  };

  render(): React.ReactElement {
    const {
      classes: { headerText, gridLayout },
      router: { location }
    } = this.props;
    const params: any = parseQueryParams(location.search) ?? {
      active: this.props?.supportResources ? Object.keys(this.props?.supportResources)?.[0] : ''
    };
    return (
      <div>
        <div className={headerText}>{params?.active}</div>
        <ul className={gridLayout}>
          {this.props.supportResources?.[params?.active]?.map((resource, index) => (
            <li key={index}>
              <SupportDocumentTile
                title={resource.title}
                description={resource.description}
                onClick={() => this.handleSelectResource(resource)}
              />
            </li>
          ))}
        </ul>
      </div>
    );
  }
}
const styles: any = {
  gridLayout: {
    display: 'grid',
    gridAutoFlow: 'row',
    gridGap: '20px 20px',
    justifyContent: 'center',
    listStyle: 'none',
    gridTemplateColumns: '1fr 1fr 1fr'
  },
  headerText: {
    margin: '50px 40px 15px 40px',
    fontFamily: FONT_GSS_FUTURA,
    fontSize: '32px',
    fontWeight: 600
  }
};
const mapStateToProps = (state: AppStoreState) => {
  return {
    selectedResource: state.app.resource.selectedResource,
    supportResources: state.entity.supportResources,
    frameType: getSwitchFrameType(
      state.app.resource.selectedResource.type,
      state.app.resource.selectedResource.mediaType
    )
  };
};
export default compose(
  withModal,
  withStyles(styles),
  withRouter,
  connect(mapStateToProps, {
    selectResource
  })
)(SupportDocuments) as any;
